<div class="select-contact-dialog">
  <div class="header" *ngIf="contactTranslation && data.titleTranslation">
    {{contactTranslation[data.titleTranslation]}}
    <button (click)="dialogRef.close('openNew')"
            class="ibexfusion-raised-button on-header small" mat-button>
      {{ data.type === 'contact' ? ('contact.createContact' | translate) : ('contact.createAddress' | translate)}}
    </button>
  </div>
  <div class="sub-header">
    <div class="sort" [class.sortUp]="sortType === 'up'" [class.sortDown]="sortType === 'down'" (click)="sort()">
      <div>{{ 'general.title' | translate }}</div>
      <mat-icon>keyboard_control_key</mat-icon>
    </div>
  </div>
  <div class="contacts-and-addresses">
    <mat-radio-group [(ngModel)]="selectedItemId">
      <div *ngFor="let ca of contactAndAddress" class="contact-and-address">
        <mat-radio-button value="{{ca._id}}">{{ca.title}}</mat-radio-button>
      </div>
    </mat-radio-group>
  </div>
  <div class="button-container">
    <button (click)="dialogRef.close()"
            class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}
    </button>
    <button (click)="select()" [disabled]="!selectedItemId" [class.mat-button-disabled]="!selectedItemId"
            class="ibexfusion-raised-button" mat-button>{{ 'general.insert' | translate }}
    </button>
  </div>
</div>

